import { useSearchParams } from 'react-router-dom'
import { FC, useMemo, useState, useEffect } from 'react'
import FormForgotPassword from './FormForgotPassword'
import MailSent from './MailSent'
import NewPasswordForm from './NewPasswordForm'
import ResetSuccessful from './ResetSuccessful'
import { ForgotPasswordpStep } from '~/app/services/auth/auth.type'

const ForgotPasswordContent: FC = () => {
  const [step, setStep] = useState<ForgotPasswordpStep>(ForgotPasswordpStep.ForgotPasswordForm)
  const [email, setEmail] = useState<string>()
  const [searchParams] = useSearchParams()
  const resetToken = searchParams.get('token')

  const renderStep = useMemo(() => {
    switch (step) {
      case ForgotPasswordpStep.ForgotPasswordForm: {
        return (
          <FormForgotPassword
            onSubmit={(email) => {
              setEmail(email)
              setStep(ForgotPasswordpStep.MailSent)
            }}
            email={email}
          />
        )
      }
      case ForgotPasswordpStep.MailSent: {
        return <MailSent onResendLink={() => setStep(ForgotPasswordpStep.ForgotPasswordForm)} />
      }
      case ForgotPasswordpStep.NewPasswordForm: {
        return <NewPasswordForm onSubmit={() => setStep(ForgotPasswordpStep.ResetSuccessful)} />
      }
      case ForgotPasswordpStep.ResetSuccessful: {
        return <ResetSuccessful />
      }
      default: {
        return <FormForgotPassword onSubmit={() => setStep(ForgotPasswordpStep.MailSent)} />
      }
    }
  }, [step, email])

  useEffect(() => {
    if (!!resetToken?.trim()) {
      setStep(ForgotPasswordpStep.NewPasswordForm)
    }
  }, [resetToken])

  return <>{renderStep}</>
}

export default ForgotPasswordContent
